import { useState } from 'react'
import { PropTypes } from 'prop-types'

import { Icon } from '@redriverpress/system'

import { RichButton } from './RichTextareaComponents'
import { richIconWidth } from './index'

export default function TextAlignment({ editor }) {
  const [currentAlignmentOption, setCurrentAlignmentOption] = useState(0)

  const textAlignmentOptions = [
    {
      icon: 'align-left',
      clickEvent: () =>
        editor
          .chain()
          .focus()
          .setTextAlign('left')
          .run(),
      active: editor.isActive('align-left'),
    },
    {
      icon: 'align-center',
      clickEvent: () =>
        editor
          .chain()
          .focus()
          .setTextAlign('center')
          .run(),
      active: editor.isActive('align-center'),
    },
    {
      icon: 'align-right',
      clickEvent: () =>
        editor
          .chain()
          .focus()
          .setTextAlign('right')
          .run(),
      active: editor.isActive('align-right'),
    },
  ]

  const MAX_INDEX = textAlignmentOptions.length - 1

  // This method is sequentially switching the options listed in the textAlignmentOptions.
  const switchAlignment = () => {
    const nextAlignmentOption =
      currentAlignmentOption === MAX_INDEX ? 0 : currentAlignmentOption + 1
    setCurrentAlignmentOption(nextAlignmentOption)
    textAlignmentOptions[nextAlignmentOption].clickEvent()
  }

  return (
    <RichButton mx={1} onClick={switchAlignment} small secondary>
      <Icon
        fontSize={0}
        icon={textAlignmentOptions[currentAlignmentOption].icon}
        width={richIconWidth}
      />
    </RichButton>
  )
}

TextAlignment.defaultProps = {
  editor: null,
}

TextAlignment.propTypes = {
  editor: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  ),
}
